import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID } from '@angular/core';
import { PreloadAllModules, provideRouter, TitleStrategy, withInMemoryScrolling, withPreloading } from '@angular/router';
import { routes } from './app.routes';
// import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { IconService } from './ui-design-library/icon.service';
import { iconLibraryInitializer } from './icon.config';
import { authInterceptorFn } from './auth/auth.interceptor';
import { CustomTitleStrategy } from './custom-title.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    // provideRouter(routes, withDebugTracing()) // TODO: Nur für's Debugging verwenden
      // withTitle(CustomTitleStrategy),
      withPreloading(PreloadAllModules),
    ),
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    provideHttpClient(withInterceptors([authInterceptorFn])),
    {
      provide: APP_INITIALIZER,
      useFactory: iconLibraryInitializer,
      deps: [IconService],
      multi: true
    },
    // provideClientHydration(),
    provideAnimationsAsync(),
    { provide: LOCALE_ID, useValue: 'de-DE' },
  ]
};
